import { WizardStepIndicator, WizardStepDef } from "@/components/ui/wizard-step-indicator";

export type EnrollmentWizardStep = "basic" | "abm" | "setup" | "support" | "devices" | "review";

const steps: WizardStepDef[] = [
  { id: "basic", name: "Basic Info", description: "Name and description" },
  { id: "abm", name: "ABM Configuration", description: "Select ABM account" },
  { id: "setup", name: "Setup Assistant", description: "Configure enrollment options" },
  { id: "support", name: "Support Info", description: "Contact information" },
  { id: "devices", name: "Device Assignment", description: "Assign devices" },
  { id: "review", name: "Review & Create", description: "Review and deploy" },
];

interface EnrollmentWizardStepsProps {
  currentStep: EnrollmentWizardStep;
  completedSteps: EnrollmentWizardStep[];
}

export const EnrollmentWizardSteps = ({ currentStep, completedSteps }: EnrollmentWizardStepsProps) => (
  <WizardStepIndicator
    steps={steps}
    currentStep={currentStep}
    completedSteps={completedSteps}
    maxWidth="max-w-6xl"
    stepSpacing="pr-4 sm:pr-12"
  />
);
